import React from "react";
import Dispatcher from "../../dispatcher";
import OverleafStore from "../../stores/overleaf-store";
import { VstButton } from "vstui";
var BookContainer = require("./book-container");

class BookListContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      sliceAmount: 15,
      highlights: {},
      ancillaries: [],
      books: {},
      toCancel: [],
      fetching: false,
      flashCardDecks: []
    };

    this._loadBadgeData = this._loadBadgeData.bind(this);
    this._scrollLibrary = this._scrollLibrary.bind(this);
    this._loadMoreBooks = this._loadMoreBooks.bind(this);
    this._goToStore = this._goToStore.bind(this);
    this._redeem = this._redeem.bind(this);
    this.nullLibraryUpdate = this.nullLibraryUpdate.bind(this);

    // Refs
    this.booklistRef = React.createRef();
  }

  componentDidMount() {
    this._isMounted = true;
    Dispatcher.bind(Dispatcher.LIBRARY_UPDATED, this._loadBadgeData);
    this._loadBadgeData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    Dispatcher.unbind(Dispatcher.LIBRARY_UPDATED, this._loadBadgeData);
    this.state.toCancel.forEach(cancel => cancel());
  }

  componentDidUpdate() {
    this._scrollLibrary();
    if (
      this.props.books &&
      this.props.books.length > 0 &&
      this.state.sliceAmount > this.props.books.length
    ) {
      if (this._isMounted) {
        this.setState({ sliceAmount: this.props.books.length });
      }
    }
  }

  _loadBadgeData() {
    Jigsaw.User.getHighlightSummary(response => {
      if (response.isSuccess() && this._isMounted) {
        this.setState({ highlights: response.data.highlights });
      }
    });
    Jigsaw.getAncillariesSummary(response => {
      if (response.isSuccess() && this._isMounted) {
        this.setState({ ancillaries: response.data.ancillaries });
      }
    });
    OverleafStore.getDecks().then(flashCardDecks => {
      this.setState({ flashCardDecks });
    });
  }

  _scrollLibrary(e) {
    if ($("#library-filter").hasClass("small-filter")) {
      if (e) {
        if (this.lastScrollTop && e.currentTarget.scrollTop > 0) {
          if (e.currentTarget.scrollTop > this.lastScrollTop) {
            // scrolling down
            this.props.hideFilter(e.currentTarget.scrollTop);
          } else if (e.currentTarget.scrollTop < this.lastScrollTop) {
            // scrolling up
            this.props.showFilter(e.currentTarget.scrollTop);
          }
        }
        this.lastScrollTop = e.currentTarget.scrollTop;
      }
    }
    if (
      this.props.books &&
      this.props.books.length > 0 &&
      this.state.sliceAmount < this.props.books.length
    ) {
      var lastBook = this.props.books[this.state.sliceAmount - 1];
      if (
        Fraction.Helpers.isScrolledIntoView(
          $(
            "#library-card-" +
              lastBook.isbn +
              "-" +
              (this.state.sliceAmount - 1) +
              "-" +
              this.props.openAssignmentCreator
          ).get(0)
        )
      ) {
        this._loadMoreBooks();
      }
    }
  }

  _loadMoreBooks(e) {
    if (
      this.props.books &&
      this.props.books.length > 0 &&
      this.state.sliceAmount < this.props.books.length
    ) {
      var sliceAmount = 14;
      if (this._isMounted) {
        this.setState({
          sliceAmount: Math.min(
            this.state.sliceAmount + 14,
            this.props.books.length
          )
        });
      }
    }
  }

  _goToStore(e) {
    e.preventDefault();
    if (Fraction.Brand.Store.sso) {
      Fraction.Helpers.ssoToOldOnlineURL(Fraction.Brand.Store.url, "_blank");
    } else {
      Fraction.Helpers.Locations.safeRedirect(
        Fraction.Brand.Store.url,
        "_blank"
      );
    }
    Fraction.Reporter.gaEvent("library/no-books/click-store");
  }

  _redeem(e) {
    e.preventDefault();
    Dispatcher.emit(Dispatcher.OPEN_MODAL, "redeem-code");
    Fraction.Reporter.gaEvent(
      "null-library/" + this.props.environment + "/redeem"
    );
  }

  nullLibraryUpdate() {
    Fraction.Helpers.userUpdateLicense({ auto: true });
    Fraction.Reporter.gaEvent(`null-library/update-license`);
  }

  render() {
    var booklistPadding = "";
    var collectionsShift = "";

    if (this.props.isCollectionsOpen) {
      collectionsShift = " collections-shift";
    }

    if (this.props.books) {
      if (this.props.books.length > 0 || this.props.loadingBookList) {
        var viewClass = this.props.view;
        if (viewClass === "grid") {
          var widthCols = 7;
          if (this.props.window.width > 1450) {
            widthCols = 7;
          } else if (this.props.window.width > 1200) {
            widthCols = 7;
          } else if (this.props.window.width > 980) {
            widthCols = 6;
          } else if (this.props.window.width > 750) {
            widthCols = 5;
          } else if (this.props.window.width > 645) {
            widthCols = 4;
          } else if (this.props.window.width > 480) {
            widthCols = 3;
          }
          viewClass +=
            " columns-" +
            Math.min(
              this.props.books.slice(0, this.state.sliceAmount).length,
              widthCols
            );
        }

        if (this.props.positionState === 3) {
          viewClass += " top-position";
        }

        if (this.props.loadingBookList && this.props.books.length === 0) {
          return (
            <ol
              id="book-list"
              ref={this.booklistRef}
              className={
                "grid top-position no-results-found" +
                collectionsShift +
                booklistPadding
              }
            >
              {i18n.t("base.loading")}...
            </ol>
          );
        } else {
          return (
            <ol
              id="book-list"
              ref={this.booklistRef}
              className={viewClass + collectionsShift + booklistPadding}
              onScroll={this._scrollLibrary}
            >
              {this.props.books
                .slice(0, this.state.sliceAmount)
                .map((book, index) => {
                  var badgeContents = {
                    highlights: this.state.highlights[book.isbn],
                    ancillaries: this.state.ancillaries.find(
                      ancillary => ancillary.isbn === book.isbn
                    ),
                    flashCardDecks: this.state.flashCardDecks.filter(
                      flashCardDeck => {
                        if (flashCardDeck.metadata) {
                          return flashCardDeck.metadata.some(
                            meta =>
                              meta.key === "isbn" && meta.value === book.isbn
                          );
                        }
                      }
                    )
                  };

                  return (
                    <BookContainer
                      {...book}
                      window={this.props.window}
                      containerViewClass={viewClass}
                      view={this.props.view}
                      isCollectionsOpen={this.props.isCollectionsOpen}
                      key={"book-" + book.isbn}
                      index={index}
                      zindex={this.props.books.length - index}
                      unavailableTypes={this.props.unavailableTypes}
                      unavailableMessage={this.props.unavailableMessage}
                      bookCount={this.state.sliceAmount}
                      badgeData={badgeContents}
                      hasAccessCode={this.state.ancillaries.some(
                        a => a.isbn === book.isbn && a.accessCodeCount
                      )}
                    />
                  );
                })}
            </ol>
          );
        }
      } else {
        let emptyLibraryText = "";
        if (Fraction.Brand.Library.emptyLibraryUpdateOption) {
          emptyLibraryText = (
            <div>
              <p>{i18n.t("filter.no-results-update-library")}</p>
              <VstButton options="btn-28" onClick={this.nullLibraryUpdate}>
                {i18n.t("main-menu.update")}
              </VstButton>
            </div>
          );
        } else if (
          this.props.hasFiltered &&
          this.props.filter !== "all" &&
          this.props.find.length > 0
        ) {
          emptyLibraryText = i18n.t("filter.no-results-for-filter", {
            term: this.props.find
          });
        } else if (this.props.find && this.props.find.length > 0) {
          emptyLibraryText = i18n.t("filter.no-results-for-find", {
            term: this.props.find
          });
        } else {
          emptyLibraryText = i18n.t("filter.no-results-on-filter");
        }
        return (
          <ol
            id="book-list"
            ref={this.booklistRef}
            className={
              "grid top-position no-results-found" +
              collectionsShift +
              booklistPadding
            }
          >
            {emptyLibraryText}
          </ol>
        );
      }
    } else {
      return (
        <div
          id="book-list"
          ref={this.booklistRef}
          className={"grid top-position" + collectionsShift + booklistPadding}
        >
          <div className="no-books-container">
            {Fraction.Brand.Graphics.watkins ? (
              <img className="large" src="/img/action_building_library.svg" />
            ) : (
              <img className="large null" src="/img/null_library.svg" />
            )}
            {Fraction.Brand.Graphics.watkins ? (
              <img
                className="small"
                src="/img/action_building_library_sm.svg"
              />
            ) : (
              <img className="small null" src="/img/null_library.svg" />
            )}
            <div className="no-books-header">{i18n.t("library.no-books")}</div>
            <div className="no-books-description">
              {Fraction.Brand.Menu.redeem && (
                <button className="submit large-button" onClick={this._redeem}>
                  {i18n.t("redeem.redeem-code")}
                </button>
              )}
              {Fraction.Brand.Store.visible && (
                <button
                  className="submit large-button"
                  onClick={this._goToStore}
                >
                  {i18n.t("library.browse-store")}
                </button>
              )}
            </div>
          </div>
        </div>
      );
    }
  }
}

BookListContainer.defaultProps = {
  openAssignmentCreator: false
};

export default BookListContainer;
